import { useState } from 'react';
import { useGiftCard } from '../../context/contexts';
import './GiftCards.css';

const GiftCards = () => {
    const { giftCards, loading, error } = useGiftCard();
    const [flippedCard, setFlippedCard] = useState(null);

    const handleCardFlip = (carTypeIndex, serviceIndex) => {
        const cardId = `${carTypeIndex}-${serviceIndex}`;
        setFlippedCard(flippedCard === cardId ? null : cardId);
    };

    const handlePurchase = (carType, service) => {
        // TODO: Implement purchase functionality
        console.log('Purchase:', carType, service);
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    return (
        <div className="gift-cards">
            <div className="gift-cards__header">
                <p className="pre-header">Gift Cards</p>
                <h1>Choose Your Perfect Gift Card</h1>
                <p className="sub-header">Select a card to view details and purchase</p>
            </div>

            <div className="gift-cards__container">
                {giftCards && giftCards.length > 0 ? (
                    giftCards.map((carType, carTypeIndex) => (
                        <div key={carType.carType} className="gift-cards__section">
                            <h2 className="gift-cards__car-type">{carType.carType}</h2>
                            <div className="gift-cards__grid">
                                {carType.services.map((service, serviceIndex) => {
                                    const cardId = `${carTypeIndex}-${serviceIndex}`;
                                    const isFlipped = flippedCard === cardId;

                                    return (
                                        <div
                                            key={service.id || service.name}
                                            className={`gift-card ${isFlipped ? 'is-flipped' : ''}`}
                                            onClick={() => handleCardFlip(carTypeIndex, serviceIndex)}
                                        >
                                            <div className="gift-card__inner">
                                                <div className="gift-card__front">
                                                    <div className="gift-card__chip"></div>
                                                    <h3>{service.name}</h3>
                                                    <div className="gift-card__price">
                                                        <span>$</span>
                                                        <span className="amount">{service.price}</span>
                                                    </div>
                                                    <p className="gift-card__note">{service.note}</p>
                                                </div>
                                                <div className="gift-card__back">
                                                    <h3>Service Details</h3>
                                                    <div className="gift-card__description">
                                                        {service.description && service.description.map((item, index) => (
                                                            <p key={index}>{item.name}</p>
                                                        ))}
                                                    </div>
                                                    <button
                                                        className="gift-card__purchase"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handlePurchase(carType, service);
                                                        }}
                                                    >
                                                        Purchase Now
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-gift-cards">
                        <p>No gift cards available at the moment.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GiftCards;